export default __webpack_public_path__ + "static/media/ic_gmx_avax.fb50658c.svg";